/* eslint-disable array-callback-return, eqeqeq, jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import {
    withRouter
} from 'react-router-dom';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import {
    fetch_physician_notifications as fetch_physician_notifications_action,
    update_physician_notification as update_physician_notification_action,
    fetch_deallocation_notifications as fetch_deallocation_notifications_action,
} from "actions/home";
import ConfirmLogoutDialog from './confirm_logout_dialog';
import IntlMessages from 'util/IntlMessages';
import UserInfo from 'components/UserInfo';
import SideNav, {
    NavItem, NavIcon, NavText
} from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import site_logo from "assets/images/logo.svg";
import device_ifu_pdf from "assets/images/pdf/IFU-20-002-Rev A.pdf";
import sleepiz_label from "assets/images/pdf/Labels_SleepizOne_20-001-03.pdf";
import webapp_ifu_pdf from "assets/images/pdf/IFUWebapp_v5.pdf";
import consent_Form_pdf from "assets/images/pdf/Consent_Form.pdf";
import config from '../../config';

dayjs.extend(utc);

const menu_options = {
    "menu-1": [
        { id: "pages.dashboard", key: "dashboard", to: "/app/", icon: "dashboard", img: "dashboard", title: "Dashboard" },
        { id: "pages.patients", key: "patients", to: "/app/patients", icon: "account-circle", img: "patient", title: "My Patients" },
        { id: "pages.real_time", key: "real_time", to: "/app/device_testing", icon: "real-time", img: "real-time", title: "Real Time" },
        { id: "pages.device_config", key: "device_config", to: "/app/device_config", icon: "device-config", img: "device-config", title: "Device Config" },
        { id: 'pages.datacenter', key: 'datacenter', to: '/app/datacenter', icon: 'datacenter', img: 'file', title: 'Data Center' },
    ],
    "menu-2": [
        { id: "pages.appointments", key: "appointments", to: "/app/appointments", icon: "accounts" },
        { id: "pages.calender", key: "calender", to: "/app/calender", icon: "timer" }
    ],
    "menu-3": [
        { id: "pages.billing", key: "billing", to: "/app/billing", icon: "card" },
        { id: "pages.reports", key: "reports", to: "/app/reports", icon: "receipt" },
        { id: "pages.settings", key: "settings", to: "/app/settings", icon: "settings" },
    ]
};
class SidenavContent extends Component {

    state = {
        notification: {
            is_notifications_open: false
        },
        unreadNotifications: 0,
        unreadDeviceNotifications: 0,
        show_confirm_logout_dialog: false,
        alert_msg_noti: 0,
        unreadReservedNotifications: 0,
    }
    componentDidMount() {
        if (this.props.membership_type !== 'paid') {
            this.props.fetch_physician_notifications();
        }
        this.props.fetch_deallocation_notifications();

        const { history } = this.props;
        const that = this;
        const pathname = `${history.location.pathname}`;// get current path

        const menuLi = document.getElementsByClassName('menu');
        for (let i = 0; i < menuLi.length; i++) {
            menuLi[i].onclick = function () {
                for (let j = 0; j < menuLi.length; j++) {
                    const parentLi = that.closest(this, 'li');
                    if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
                        menuLi[j].classList.remove('open')
                    }
                }
                this.classList.toggle('open');
            }
        }

        const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
        try {
            const activeNav = this.closest(activeLi, 'ul'); // select closest ul
            if (activeNav) {
                if (activeNav.classList.contains('sub-menu')) {
                    this.closest(activeNav, 'li').classList.add('open');
                } else {
                    this.closest(activeLi, 'li').classList.add('open');
                }
            }
        } catch (error) {
            console.log(error)
        }

    }

    componentDidUpdate(prev) {
        if (prev === this.props) {
            return;
        }

        if (this.props.home !== null
            && this.props.home.fetched_physician_notifications !== null
            && this.props.home.fetched_physician_notifications.length > 0) {
            let totalUnreadNotifications = 0;
            this.props.home.fetched_physician_notifications.forEach(item => {
                if (item.is_read === 0) {
                    ++totalUnreadNotifications;
                }
            });
            this.setState({ unreadNotifications: totalUnreadNotifications });
        }
        if (this.props.home !== null
            && this.props.home.fetched_deallocation_notifications !== null
            && this.props.home.fetched_deallocation_notifications.length > 0) {
            let totaldeviceNotifications = 0;
            if (this.props.home.fetched_deallocation_notifications.length > 0) {
                totaldeviceNotifications = 1;
            }
            this.setState({ unreadDeviceNotifications: totaldeviceNotifications });
        }
        if (this.props.home !== null
            && this.props.home.fetched_reserved_data_notifications !== null
            && this.props.home.fetched_reserved_data_notifications.length > 0) {
            let totalreservedNotifications = 0;
            if (this.props.home.fetched_reserved_data_notifications.length > 0) {
                totalreservedNotifications = 1;
            }
            this.setState({ unreadReservedNotifications: totalreservedNotifications });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { history } = nextProps;
        const pathname = `${history.location.pathname}`;// get current path

        const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
        try {
            const activeNav = this.closest(activeLi, 'ul'); // select closest ul
            if (activeNav) {
                if (activeNav.classList.contains('sub-menu')) {
                    this.closest(activeNav, 'li').classList.add('open');
                } else {
                    this.closest(activeLi, 'li').classList.add('open');
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    closest(el, selector) {
        try {
            let matchesFn;
            // find vendor prefix
            ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
                if (typeof document.body[fn] == 'function') {
                    matchesFn = fn;
                    return true;
                }
                return false;
            });

            let parent;

            // traverse parents
            while (el) {
                parent = el.parentElement;
                if (parent && parent[matchesFn](selector)) {
                    return parent;
                }
                el = parent;
            }
        } catch (e) {
            console.log(e)
        }

        return null;
    }

    show_notifications = (type) => {
        const { notification } = this.state;
        notification.is_notifications_open = type === "hide" ? false : !notification.is_notifications_open;

        this.setState(notification);
        document.getElementsByClassName("notification-moremenu")[0].classList.remove('active');
    }

    hide_confirm_logout_dialog = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ show_confirm_logout_dialog: false });
    }

    toggleSidebar = () => {
        sessionStorage.setItem("sidebar", false)
        this.setState(prevState => ({
            showSidebar: !prevState.showSidebar
        }));

    }

    handleClickAway = () => {
        sessionStorage.setItem("sidebar", false)
        this.setState({ showSidebar: false });
    }

    updateNotificationHandle = (notification) => {
        this.setState({ showSidebar: false });

        if (!notification && !notification.id && notification.id === '') {
            return;
        }

        if (notification.is_read === 0) {
            this.props.update_physician_notification({ id: notification.id });
        }

        const night = dayjs.utc(dayjs.utc(notification.night).format('YYYY-MM-DD')).format('X');
        const url = "/app/patients/id=" + notification.patient_id + "?night=" + night;
        // console.log(url);
        this.props.history.push(url);
    }

    showMoreMenuHandler = (element) => {
        document.getElementsByClassName(element)[0].classList.remove('active');
    }

    hideMoreMenuHandler = (element, eventType) => {
        if (eventType === 'blur') {
            setTimeout(() => {
                document.getElementsByClassName(element)[0].classList.remove('active');
            }, 10)
        } else if (eventType === 'leave') {
            document.getElementsByClassName(element)[0].classList.remove('active');
        }
    }

    render() {
        const { user_sign_out, is_annotator, alert_msg } = this.props;
        const showSidebarMenu = sessionStorage.getItem("sidebar") ? false : true
        let display_version;
        if (config.show_site_version) {
            display_version = <div>{"v" + config.site_version}</div>;
        }

        let label_menu_link = sleepiz_label;

        let devices = []
        let deallocation_date = []
        let message;
        let reservedMessage;
        let reservedDevices = []
        let reserved_deallocation_date = []
        if (this.props.home !== null
            && this.props.home.fetched_deallocation_notifications !== null
            && this.props.home.fetched_deallocation_notifications.length > 0) {
            this.props.home.fetched_deallocation_notifications.map(item => devices.push(item.device_id))
            this.props.home.fetched_deallocation_notifications.map(item => deallocation_date.push(dayjs(item.device_deallocation_date).format('DD MMM YYYY')))
            message = <div className="notification-item"> De-allocation Date(s) are on <strong>{deallocation_date.join()}</strong> for <strong>{devices.join()}</strong> Device(s). Please contact Sleepiz Admin. </div>;
        }
        if (this.props.home !== null
            && this.props.home.fetched_reserved_data_notifications !== null
            && this.props.home.fetched_reserved_data_notifications.length > 0) {
            this.props.home.fetched_reserved_data_notifications.map(item => reservedDevices.push(item.device_id))
            this.props.home.fetched_reserved_data_notifications.map(item => reserved_deallocation_date.push((item.allocated_date)))
            reservedMessage = <div className="notification-item"> Device(s) <strong>{reservedDevices.join()}</strong> have been reserved to patients for dates <strong>{reserved_deallocation_date.join()}</strong>. Please Extend or Return the Devices or the reservations made will be canceled. </div>;
        }
        return (
            <ClickAwayListener onClickAway={this.handleClickAway}>
                <SideNav id="sidebar-nav" className={"sidebar-nav" + ((this.state.showSidebar || showSidebarMenu) && (window.location.pathname !== '/app/realtimeDashboard') ? " active" : "")}>
                    <div className="nav-logo"><img src={site_logo} alt="Sleepiz" /></div>
                    <span className="sidebar-button" onClick={this.toggleSidebar} >
                        <span className="sidenav-icon-bar"></span>
                        <span className="sidenav-icon-bar"></span>
                        <span className="sidenav-icon-bar"></span>
                    </span>
                    {/* <SideNav.Toggle title="Menu" className="sidebar-button" /> */}
                    <SideNav.Nav className="top-nav" defaultSelected="home">
                        {
                            menu_options["menu-1"].map((option, index) => {
                                let homeMenuMatch = false;
                                if (option.to === '/app/') {
                                    homeMenuMatch = true;
                                }

                                if (is_annotator && (option.key === 'dashboard')) {
                                    return;
                                }
                                
                                if (is_annotator && option.key === 'device_config') {
                                    return;
                                }
                                return (
                                    <LinkContainer key={'link-container-' + index} to={option.to} exact={homeMenuMatch} activeClassName="active-link">
                                        <NavItem onClick={this.handleClickAway} className="nav-item">
                                            <NavIcon title={option.title}>
                                                <span className={`icon icon-${option.img}`}></span>
                                            </NavIcon>
                                            <NavText>
                                                <IntlMessages id={option.id} />
                                            </NavText>
                                        </NavItem>
                                    </LinkContainer>
                                );
                            })
                        }
                    </SideNav.Nav>
                    <SideNav.Nav className={"bottom-nav " + (display_version ? "display_version" : "")}>
                        <NavItem
                            className="nav-item moremenu-item page-moremenu-item"
                            onClick={() => this.showMoreMenuHandler("page-moremenu-item")}
                        >
                            <NavIcon>
                                <span className="icon icon-more"></span>
                            </NavIcon>
                            <NavText>
                                <span><IntlMessages id="so.more"></IntlMessages></span>
                            </NavText>
                            <div
                                className="submenu-list"
                                onClick={() => this.hideMoreMenuHandler("page-moremenu-item", "blur")}
                            >
                                <div onClick={this.handleClickAway} className="submenu-item"><a href={label_menu_link} target="_blank" rel="noopener noreferrer"><IntlMessages id="mail.labels"></IntlMessages></a></div>
                                <div onClick={this.handleClickAway} className="submenu-item"><a href="mailto:info@sleepiz.com" target="_blank" rel="noopener noreferrer" ><IntlMessages id="component.footer.get_support"></IntlMessages></a></div>
                                <div onClick={this.handleClickAway} className="submenu-item"><a href="/app/privacy-policy" target="_blank" rel="noopener noreferrer"><IntlMessages id="sidebar.privacyPolicy"></IntlMessages></a></div>
                                <div onClick={this.handleClickAway} className="submenu-item"><a href="/app/terms-of-use" target="_blank" rel="noopener noreferrer"><IntlMessages id="sidebar.termsofuse"></IntlMessages></a></div>
                                <div onClick={this.handleClickAway} className="submenu-item"><a href={device_ifu_pdf} target="_blank" rel="noopener noreferrer" ><IntlMessages id="sidebar.deviceInstructions"></IntlMessages></a></div>
                                <div onClick={this.handleClickAway} className="submenu-item"><a href={webapp_ifu_pdf} target="_blank" rel="noopener noreferrer" ><IntlMessages id="sidebar.webappuserManual"></IntlMessages></a></div>
                                <div onClick={this.handleClickAway} className="submenu-item"><a href={consent_Form_pdf} target="_blank" rel="noopener noreferrer" ><IntlMessages id="sidebar.patientInformation"></IntlMessages> </a></div>
                                <div onClick={this.handleClickAway} className="submenu-item"><a href="/app/faq" target="_blank" rel="noopener noreferrer">FAQ</a></div>
                            </div>
                        </NavItem>
                        <NavItem className="nav-item profile-item">
                            <UserInfo handleClickAwayEvent={this.handleClickAway} />
                        </NavItem>
                        {!is_annotator && (
                            <NavItem
                                className="nav-item moremenu-item notification-moremenu"
                                backdrop=""
                                onClick={this.show_notifications}
                            >
                                <NavIcon title="Notifications">
                                    <span className="icon icon-notification"></span>
                                    {
                                        !this.state.unreadNotifications
                                            || this.state.unreadNotifications === 0 ? null :
                                            (
                                                <span className="notification-count">{this.state.unreadNotifications}</span>
                                            )
                                    }
                                    {
                                        !(this.state.unreadDeviceNotifications && !this.state.unreadReservedNotification)
                                            || (this.state.unreadDeviceNotifications === 0 && this.state.unreadReservedNotifications === 0) ? null :
                                            (
                                                <span className="notification-count">{this.state.unreadDeviceNotifications + this.state.unreadReservedNotifications}</span>
                                            )
                                    }
                                    {
                                        alert_msg && (
                                            <span className="notification-count"></span>
                                        )
                                    }

                                </NavIcon>
                                <NavText>
                                    <span>Notifications</span>
                                </NavText>
                                <div className="submenu-list notification-wrap">
                                    <div
                                        onClick={() => this.hideMoreMenuHandler("notification-moremenu", "blur")}
                                        className="notification-list">
                                        {
                                            this.props.home
                                            && this.props.home.fetched_physician_notifications
                                            && this.props.home.fetched_physician_notifications.length === 0
                                            && this.props.home.fetched_deallocation_notifications
                                            && this.props.home.fetched_deallocation_notifications.length === 0
                                            && !alert_msg && (
                                                <div className="no-notification-item"><IntlMessages id="sidebar.notificationsMsg"></IntlMessages></div>
                                            )
                                        }
                                        {
                                            this.props.home
                                            && this.props.home.fetched_physician_notifications
                                            && this.props.home.fetched_physician_notifications.length > 0
                                            && this.props.home.fetched_physician_notifications.map(item => {
                                                return (
                                                    <div key={item.id} onClick={() => this.updateNotificationHandle(item)} className={"notification-item " + (item.is_read === 0 ? "unread-notification" : "")}><strong>{item.patient_code}</strong> is found with <strong>{item.apnea_events}</strong> apnea event on <strong>{dayjs(item.night).format('DD MMM')}</strong> night.</div>
                                                )
                                            })
                                        }
                                        {message}
                                        {reservedMessage}
                                        {alert_msg}
                                    </div>
                                </div>
                            </NavItem>
                        )}
                        <NavItem className="nav-item logout-item" onClick={() => {
                            this.setState({ show_confirm_logout_dialog: true });

                        }}>
                            {this.state.show_confirm_logout_dialog && <ConfirmLogoutDialog onCancel={this.hide_confirm_logout_dialog} onConfirm={
                                user_sign_out
                            } />}
                            <NavIcon title="Logout">
                                <span className="icon icon-logout"></span>
                            </NavIcon>
                            <NavText>
                                <IntlMessages id="popup.logout" />
                            </NavText>
                        </NavItem>
                    </SideNav.Nav>
                    <div className="copyright-text">
                        <div>Sleepiz © {dayjs.utc().format('YYYY')}.<span><IntlMessages id="main.allRightsReserved"></IntlMessages>.</span></div>
                        {display_version}
                    </div>
                </SideNav>
            </ClickAwayListener>
        );
    }
}

const mapStateToProps = (state) => ({
    home: { ...state.home },
    is_annotator: state.user.is_annotator,
    membership_type: state.user.user_details.membership_type,
    live_device_list: state.user.live_device_list,
    alert_msg: state.realtime.alert_msg
});

const mapDispatchToProps = dispatch => ({
    fetch_physician_notifications: () => dispatch(fetch_physician_notifications_action()),
    update_physician_notification: (payload) => dispatch(update_physician_notification_action(payload)),
    fetch_deallocation_notifications: () => dispatch(fetch_deallocation_notifications_action()),
});

// export default withRouter(SidenavContent);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SidenavContent));
